import styled from "styled-components";

export const Container = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 1100px;
  margin: 0 auto;
`;

export const Title = styled.h1`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.4rem;
  margin: 0;
  color: var(--text);
`;

export const Subtitle = styled.p`
  margin: -12px 0 0;
  font-size: 0.85rem;
  color: var(--text-muted);
`;

export const Card = styled.section`
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--surface-2);
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CardTitle = styled.h2`
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--accent);
`;

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
`;

export const ImageSlots = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 16px;
`;

export const ImageSlotCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 12px;
  background: var(--surface);

  .slot-name {
    font-size: 0.8rem;
    font-weight: 700;
    color: var(--text);
  }

  .slot-hint {
    font-size: 0.72rem;
    color: var(--text-muted);
    min-height: 2.2em;
  }
`;

export const ImagePreview = styled.div`
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed var(--border);
  border-radius: 8px;
  background: var(--surface-2);
  overflow: hidden;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  span {
    font-size: 0.75rem;
    color: var(--text-muted);
  }
`;

export const SlotActions = styled.div`
  display: flex;
  gap: 8px;
`;

export const ContactBlock = styled.div`
  display: grid;
  grid-template-columns: minmax(180px, 1fr) minmax(240px, 2fr) auto;
  gap: 12px;
  align-items: start;
  border-top: 1px solid var(--border);
  padding-top: 14px;

  &:first-of-type {
    border-top: none;
    padding-top: 0;
  }
`;

export const SwitchGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 4px 16px;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  position: sticky;
  bottom: 0;
  padding: 12px 0;
  background: var(--surface);
`;

export const ColorRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  input[type="color"] {
    width: 52px;
    height: 40px;
    padding: 0;
    border: 1px solid var(--border);
    border-radius: 8px;
    background: none;
    cursor: pointer;
  }
`;
